import { graphql } from '@teachino/shared-infrastructure';

export const deleteTopicsMutation = graphql(`
  mutation DeleteTopics($topicIds: [String!]!, $force: Boolean!) {
    removeTopics(
      multiTopicRemoveInput: { topicIds: $topicIds, forceDelete: $force }
    ) {
      __typename
      done
    }
  }
`);
